export const BRAND = {
  name: 'Lily Book Club',
  logoAlt: 'Logo Lily Book Club',
};

/* O FAQ virou seção da home, então vira âncora. O Sobre continua
   página própria. O nome fica "FAQ": é por ele que a leitora procura,
   não pelo id da seção. */
export const NAV_LINKS = [
  { name: 'Início', path: '/' },
  { name: 'Sobre', path: '/sobre' },
  { name: 'FAQ', path: '/#duvidas' },
];

export const WHATSAPP_NUMBER = '5511999999999'; // Exemplo
